import  gql  from 'graphql-tag'

export const CREATE_ACTIVITY_TYPE = gql`mutation activityType($input: ActivityTypeMutationInput!){
    activityType(input: $input){
        activityType{
            id
            code
            name
            isActive
        }
        errors{
            field
            messages
        }
    }
}`;